/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bench_LinkInputs */

const en_fw_bench_link = /** @type {(inputs: Fw_Bench_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the benchmark`)
};

const id_fw_bench_link = /** @type {(inputs: Fw_Bench_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat benchmark`)
};

/**
* | output |
* | --- |
* | "See the benchmark" |
*
* @param {Fw_Bench_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bench_link = /** @type {((inputs?: Fw_Bench_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bench_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bench_link(inputs)
	return en_fw_bench_link(inputs)
});